<div class="mb-2 d-flex justify-content-between">
  <div class="section-header">
    {{ header }} <span *ngIf="showLength" class="text-muted font-weight-light">({{ activities.length }})</span>
  </div>
  <!-- <a href="#" *ngIf="showLength">View completed</a> -->
</div>
<div class="ml-n3 mr-n3 ml-md-n5 mr-md-n5 ml-xl-0 mr-xl-0">
  <div class="swiper-container" [swiper]="extraInfoConfig" [(index)]="index" *ngIf="activities.length > 0" (swiperEvent)="indexChange($event)">
    <div class="swiper-wrapper d-flex align-items-stretch">
      <div class="swiper-slide h-100" *ngFor="let activity of activities">
        <common-activity-card [activity]="activity" (dismissed)="dismissed($event)"></common-activity-card>
      </div>
    </div>

    <div class="swiper-button-prev swiper-button-activity b-grey bg-white d-none d-lg-flex" (click)="previous()"></div>
    <div class="swiper-button-next swiper-button-activity b-grey bg-white d-none d-lg-flex" (click)="next()"></div>
  </div>
</div>
<div class="font-weight-light" *ngIf="activities.length == 0">You do not have anything to do.</div>
